import React from 'react';

import AttendTimeRecorder from 'components/organismos/AttendTimeRecorder/AttendTimeRecorder';

const TimeRecorderPage: React.FC = () => (
  <AttendTimeRecorder />
);

export default TimeRecorderPage;
